import { type FC } from 'react'
import { graphql, useFragment } from 'react-relay'

import { type ProfileHeaderTitle_profile$key } from '@/__generated__/ProfileHeaderTitle_profile.graphql'
import { HeaderTitle, ProfileAvatar, type HeaderTitleProps } from '@/components'

export interface ProfileHeaderTitleProps extends Omit<HeaderTitleProps, 'left' | 'title' | 'subtitle'> {
  accessibilityPrefix?: string
  isOnline?: boolean
  profileRef: ProfileHeaderTitle_profile$key | null | undefined
  withAvatar?: boolean
  withOnline?: boolean
}

export const ProfileHeaderTitle: FC<ProfileHeaderTitleProps> = ({
  accessibilityLabel: _accessibilityLabel,
  accessibilityPrefix,
  isOnline,
  profileRef,
  withAvatar,
  withOnline,
  ...props
}) => {
  const profileData = useFragment(
    graphql`
      fragment ProfileHeaderTitle_profile on Profile {
        age
        closestCity
        name
        isVerified
        ...ProfileAvatar_profile
      }
    `,
    profileRef
  )

  return (
    <HeaderTitle
      accessibilityLabel={`${accessibilityPrefix ?? 'Profile screen'}: ${profileData?.name}, Age: ${profileData?.age}${profileData?.closestCity ? `, Location: ${profileData?.closestCity}` : ''}${profileData?.isVerified ? ', Verified' : ''}`}
      left={
        withAvatar ? (
          <ProfileAvatar
            className='h-8 w-8'
            isOnline={isOnline}
            profileRef={profileData}
            showOnline={withOnline}
          />
        ) : null
      }
      title={`${profileData?.name}, ${profileData?.age}`}
      subtitle={profileData?.closestCity}
      {...props}
    />
  )
}
